import { Tag, Typography } from "antd";
import dayjs from "dayjs";
import { IoMdTime } from "react-icons/io";
import {
  TagDeliveryNoteStatus,
  TagSalesOrderStatus,
} from "../../components/badge-and-tag";
import { comma, formatMoney } from "../../utils/util";

const WaitingTag = (v) => {
  const diffInDays = dayjs(new Date()).diff(dayjs(v), "day");
  return diffInDays < 1 ? (
    <Tag color="#3ab38a">วันนี้</Tag>
  ) : (
    <Tag color="#b4b4b1">{diffInDays} วันที่แล้ว</Tag>
  );
};

export const salesOrderListColumn = ({ handleShowDetail }) => [
  {
    title: "เลขที่ใบขายสินค้า",
    key: "socode",
    dataIndex: "socode",
    align: "left",
    render: (value, record) => (
      <Typography.Link onClick={() => handleShowDetail(record)}>
        {value || "-"}
      </Typography.Link>
    ),
  },
  {
    title: "วันที่ใบขายสินค้า",
    key: "sodate",
    dataIndex: "sodate",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "ชื่อลูกค้า",
    key: "cusname",
    dataIndex: "cusname",
    align: "left",
  },
  {
    title: "สถานะเอกสาร",
    key: "doc_status",
    dataIndex: "doc_status",
    render: (value) => <TagSalesOrderStatus result={value} />,
  },
  {
    title: "ระยะเวลา",
    key: "waiting_days",
    dataIndex: "sodate",
    render: WaitingTag,
  },
];

export const deliveryNoteListColumn = [
  {
    title: "",
    key: "ind",
    dataIndex: "ind",
    width: 20,
    render: () => <IoMdTime color="#ff7e23" style={{ fontSize: "1.3rem" }} />,
  },
  {
    title: "เลขที่ใบส่งของ",
    key: "dncode",
    dataIndex: "dncode",
    align: "left",
  },
  {
    title: "วันที่ใบส่งของ",
    key: "dndate",
    dataIndex: "dndate",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "ชื่อลูกค้า",
    key: "cusname",
    dataIndex: "cusname",
    align: "left",
  },
  {
    title: "สถานะเอกสาร",
    key: "doc_status",
    dataIndex: "doc_status",
    render: (value) => <TagDeliveryNoteStatus result={value} />,
  },
  {
    title: "ระยะเวลา",
    key: "waiting_days",
    dataIndex: "dndate",
    render: WaitingTag,
  },
];

export const salesOrderDetailColumn = [
  {
    title: "ชื่อสินค้า",
    key: "stname",
    dataIndex: "stname",
  },
  {
    title: "หน่วย",
    key: "unit",
    dataIndex: "unit",
    align: "left",
  },
  {
    title: "จำนวน",
    key: "qty",
    dataIndex: "qty",
    align: "right",
    render: (v) => comma(Number(v || 0), 2, 2),
  },
  {
    title: "ราคาขาย",
    key: "price",
    dataIndex: "price",
    align: "right",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "VAT (%)",
    key: "vat",
    dataIndex: "vat",
    align: "right",
    render: (v) => comma(Number(v || 0), 0),
  },
  {
    title: "ราคารวมสุทธิ",
    key: "totalnet",
    dataIndex: "totalnet",
    align: "right",
    render: (_, record) => {
      const base = Number(record?.qty || 0) * Number(record?.price || 0);
      const net = base * (1 + Number(record?.vat || 0) / 100);

      return formatMoney(net, 2);
    },
  },
];

export const statisticValue = {
  daily: 0,
  weekly: 0,
  monthly: 0,
  yearly: 0,
  waiting: 0,
};
